// Utils
import classnames from 'classnames'
import React from 'react'

import { RichText, RichTextProps } from '../../molecules/RichText'
import Button, { ButtonProps } from '../button'
import { Image, ImageProps } from '../image'

import styles from './iconWithTextfeature.module.scss'

export interface IconWithTextfeatureProps {
  iconProps?: ImageProps
  heading?: string
  description?: RichTextProps
  className?: string
  align?: string
  hasBorder?: boolean
  imageWrapperClassName?: string
  button?: ButtonProps
}

const IconWithTextfeature = ({
  className = '',
  heading = '',
  align = 'center',
  hasBorder = false,
  ...props
}: IconWithTextfeatureProps) => {
  const wrapClassnames = classnames(
    styles.iconWithTextWrap,
    styles['align__' + align],
    { [styles.hasBorder]: hasBorder },
    className,
  )
  return (
    <div className={wrapClassnames}>
      {props.iconProps && (
        <div className={classnames(styles.imageWrapper, props.imageWrapperClassName)}>
          <Image {...props.iconProps} className={classnames(styles.icon, props.iconProps.className)} />
        </div>
      )}
      <div className={styles.contentWrapper}>
        {heading !== '' && <h6>{heading}</h6>}
        {props.description && <RichText {...props.description} />}
        {props.button && <Button {...props.button} />}
      </div>
    </div>
  )
}

export default IconWithTextfeature
